import React, { PropTypes, Component } from 'react'
import { connect } from 'react-redux'
import Helmet from 'react-helmet'
import moment from 'moment'

// Styles
import classes from './Product.scss'

// Actions
import { orderActions, productActions, userActions } from 'redux/actionCreators'

import { ProductItem } from 'components'

// Helpers
import _get from 'lodash.get'
import _isEqual from 'lodash.isequal'
import _compact from 'lodash.compact'
import _find from 'lodash.find'
import { resolveBackSlash } from 'helpers/formHelpers'
import { formatMoney } from 'helpers/utilities'
import { viewportWidth } from '../../../helpers/utilities'

const mapStateToProps = (state) => ({
  userClass: _get(state, ['user', 'me', 'userClass']) || 0,
  product: _get(state, ['product', 'product']) || {},
  productImages: _get(state, 'product.productImages') || [],
  recommendations: _get(state, 'product.recommendations') || [],
  bannerMap: _get(state, ['banner', 'bannerMap']) || {},
  cartProductMap: _get(state, ['order', 'cartProductMap']) || {}
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  attemptFindOneProduct: (props) =>
    dispatch(productActions.attemptFindOneProduct({
      productCode: _get(props, 'params.productCode')
    })),
  attemptFindProductImages: (props) =>
    dispatch(productActions.attemptFindProductImages({
      productCode: _get(props, 'params.productCode')
    })),
  attemptFindProductRecommendations: (props) =>
    dispatch(productActions.attemptFindProductRecommendations({
      productCode: _get(props, 'params.productCode')
    })),
  attemptAddToCart: (payload) =>
    dispatch(orderActions.attemptAddToCart(payload)),
  attemptAddToWishlist: (productCode) =>
    dispatch(userActions.attemptAddToWishlist({ productCode })),
  attemptRemoveFromWishlist: (productCode) =>
    dispatch(userActions.attemptRemoveFromWishlist({ productCode })),
  openProductModal: (productKey, amount) =>
    dispatch({ type: 'PRODUCT_MODAL_OPEN', productKey, amount, closeHidden: true })
})

@connect(mapStateToProps, mapDispatchToProps)
class ProductDetail extends Component {
  static propTypes = {
    userClass: PropTypes.number.isRequired,
    product: PropTypes.object.isRequired,
    productImages: PropTypes.array.isRequired,
    cartProductMap: PropTypes.object.isRequired,
    attemptFindOneProduct: PropTypes.func.isRequired,
    attemptAddToCart: PropTypes.func.isRequired
  };

  static contextTypes = {
    router: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props)
    this.state = {
      amount: _get(props.cartProductMap, [`${props.params.productCode}-${props.location.query.unitId || 0}`, 'amount']) || 0
    }
  }

  componentDidMount() {
    window.objectFitImages()
    const images = document.getElementsByTagName('img')
    Object.keys(images).forEach(key => images[key].addEventListener('contextmenu', () => false))

    if (viewportWidth() < 768) {
      const productKey = `${this.props.params.productCode}-${this.props.location.query.unitId || 0}`
      const amount = _get(this.props.cartProductMap, [productKey, 'amount']) || 0
      this.props.openProductModal(productKey, amount)
    }
  }

  componentWillMount() {
    this._fetchData(this.props)
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.params.productCode !== nextProps.params.productCode) {
      this._fetchData(nextProps)
    }
    if ((this.props.location.query.unitId || '0') !== (nextProps.location.query.unitId || '0')) {
      this.setState({ amount: _get(nextProps, ['cartProductMap', `${nextProps.params.productCode}-${nextProps.location.query.unitId || 0}`, 'amount']) || 0 })
    }

    if (!_isEqual(this.props.cartProductMap, nextProps.cartProductMap)) {
      const productCode = nextProps.params.productCode
      this.setState({ amount: _get(nextProps, ['cartProductMap', `${productCode}-${nextProps.location.query.unitId || 0}`, 'amount']) || 0 })
    }
  }

  _fetchData = (props) => {
    this.props.attemptFindOneProduct(props)
    this.props.attemptFindProductImages(props)
    this.props.attemptFindProductRecommendations(props)
  }

  _onAmountChange = (value, stockAmount) => {
    if (value && isNaN(value)) return
    value = value ? parseInt(value, 10) : 0;
    this.setState({ amount: `${Math.min(value, stockAmount)}` })
  }

  _onEnter = (e) => {
    if (e.keyCode === 13) this._onAddToCart()
  }

  _onAddToCart = () => {
    const selectedUnitId = _get(this.props, 'location.query.unitId') || '0'
    const selectedUnit = _find(this.props.product.units, unit => `${unit.unitId}` === selectedUnitId)

    this.props.attemptAddToCart({
      productCode: _get(this.props, ['product', 'productCode']),
      amount: this.state.amount,
      price: this._price(selectedUnit),
      unitId: selectedUnitId
    })
  }

  _onRemoveFromCart = () => {
    const selectedUnitId = _get(this.props, 'location.query.unitId') || '0'
    const selectedUnit = _find(this.props.product.units, unit => `${unit.unitId}` === selectedUnitId)

    this.setState({ amount: 0 }, () => this.props.attemptAddToCart({
      productCode: _get(this.props, ['product', 'productCode']),
      amount: 0,
      price: this._price(selectedUnit),
      unitId: selectedUnitId
    }))
  }

  _price = (unit) =>
    unit[['retail', 'wholesale1', 'wholesale2', 'wholesale3', 'wholesale4'][this.props.userClass]]

  _renderBanner = (banner, index) =>
    <div key={index} className={classes.banner}>
      <a href={banner.link}>
        <img src={banner.path} role='presentation' />
      </a>
    </div>

  _onOpenModal = (modalImagePath) =>
    this.setState({ modalVisible: true, modalImagePath })

  _onCloseModal = () =>
    this.setState({ modalVisible: false, modalImagePath: '' })

  _onWishlist = (alreadyAdded) => {
    const { productCode } = this.props.product || {}
    if (alreadyAdded) {
      this.props.attemptRemoveFromWishlist(productCode)
    } else {
      this.props.attemptAddToWishlist(productCode)
    }
  }

  _renderProduct = (product) =>
    <div key={product.productCode} className={classes.productItemWrapper}>
      <ProductItem
        product={product}
        amount={_get(this.props, ['cartProductMap', `${product.productCode}-0`, 'amount'])}
        userClass={this.props.userClass}
        onAddToCart={this.props.attemptAddToCart}
        onAddToWishlist={this.props.attemptAddToWishlist}
        onRemoveFromWishlist={this.props.attemptRemoveFromWishlist} />
    </div>

  render() {
    const { product, productImages, bannerMap, cartProductMap, recommendations, params: { productCode } } = this.props
    const banners = _compact([bannerMap['product-banner1'], bannerMap['product-banner2'], bannerMap['product-banner3'], bannerMap['product-banner4'], bannerMap['product-banner5']])
    const selectedUnitId = _get(this.props, 'location.query.unitId') || '0'
    const smallestUnit = _get(_find(product.units, unit => unit.perUnit === 1), 'unit')
    const selectedUnit = _find(product.units, unit => `${unit.unitId}` === selectedUnitId)
    const stockAmount = selectedUnit
      ? Math.floor(product.stockAmount / selectedUnit.perUnit)
      : product.stockAmount

    console.log({ selectedUnitId, smallestUnit, selectedUnit, stockAmount })

    return (
      <section className={classes.productDetail}>
        <Helmet title={product.productName} />
        <div className='desktop'>
          <div className={classes.images}>
            <div className={classes.thumbnailWrapper}
              onClick={() => this._onOpenModal(product.imagePath)}>
              <img className={classes.thumbnail}
                src={product.imagePath}
                role='presentation' />
              <div className={classes.wmWrapper}>
                {Boolean(product.freeDelivery) && <img className={classes.freeDelivery} src='/images/icon-free-shipping.svg' alt='Free Delivery' />}
                <img className={classes.wm}
                  src='/images/watermark.png'
                  alt='watermark' width='132' height='44' />
              </div>
            </div>
            {_get(productImages, 0) && (
              <div className={`desktop ${classes.productImages}`}>
                <div>
                  {productImages.map(pimg =>
                    <div className={classes.pImg} onClick={() => this._onOpenModal(pimg.imagePath)}>
                      <img role='presentation' className={classes.thumbnail} src={pimg.imagePath} />
                      <div className={classes.wmWrapper}>
                        {Boolean(product.freeDelivery) && <img className={classes.freeDelivery} src='/images/icon-free-shipping.svg' alt='Free Delivery' />}
                        <img role='presentation' className={classes.wm} src='/images/watermark.png' alt='watermark' width='132' height='44' />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
          <div className={classes.info}>
            <h1>{resolveBackSlash(product.productName)}</h1>
            <div className={classes.row}>
              <div className={classes.colLeft}>
                <span>Generic Name</span>
              </div>
              <div className={classes.colRight}>
                <span>: {product.genericName || '-'}</span>
              </div>
            </div>
            <div className={classes.row}>
              <div className={classes.colLeft}>
                <span>บริษัทผู้จัดจำหน่าย</span>
              </div>
              <div className={classes.colRight}>
                <span>: {product.companyName}</span>
              </div>
            </div>
            <div className={classes.row}>
              <div className={classes.colLeft}>
                <span>รหัสสินค้า</span>
              </div>
              <div className={classes.colRight}>
                <span>: {productCode}</span>
              </div>
            </div>
            {selectedUnit && selectedUnit.expDate && (
              <div className={`${classes.row} ${classes.remark}`}>
                <div className={classes.colLeft}>
                  <span>วันหมดอายุ</span>
                </div>
                <div className={classes.colRight}>
                  <span>{moment(selectedUnit.expDate, 'YYYY-MM-DD').diff(moment(), 'month') >= 12
                    ? <b>: รับประกันอายุสินค้าเกิน 12 เดือน</b>
                    : <b>: {moment(selectedUnit.expDate, 'YYYY-MM-DD').format('DD/MM/YYYY')}</b>}</span>
                </div>
              </div>
            )}
            {product.packageSize && (
              <div className={classes.row}>
                <div className={classes.colLeft}>
                  <span>หน่วยบรรจุ</span>
                </div>
                <div className={classes.colRight}>
                  <span>: {product.packageSize}</span>
                </div>
              </div>
            )}
            {product.remark && (
              <div className={`${classes.row} ${classes.remark}`}>
                <div className={classes.colLeft}>
                  <span>หมายเหตุ</span>
                </div>
                <div className={classes.colRight}>
                  <span>: {product.remark}</span>
                </div>
              </div>
            )}
            <div className={`${classes.row} ${classes.unitSelector}`}>
              <div className={classes.unitHead}>หน่วย</div>
              {(product.units || [])
                .filter(data => parseFloat(this._price(data), 10) > 0)
                .map(({ unit, unitId, perUnit, ...rest }) =>
                  <div key={unitId}
                    className={`${classes.unitItem} ${`${unitId}` === selectedUnitId && classes.active}`}
                    onClick={() => this.context.router.replace(`/products/${productCode}?unitId=${unitId}`)}>
                    <div className={classes.unitTitle}>{unit}</div>
                    <div className={classes.unitPrice}>{formatMoney(this._price(rest))} บาท</div>
                    <div className={classes.perUnit}>({formatMoney(this._price(rest) / (perUnit || 1))} บาท/{smallestUnit})</div>
                  </div>
                )}
            </div>
            {product.outOfStock ? (
              <div className={classes.amount}>
                <span className={classes.outOfStock}>สินค้าหมดชั่วคราว</span>
                {Boolean(this.state.amount) && (
                  <div style={{ marginLeft: 20 }} className={classes.btnCart} onClick={this._onRemoveFromCart}>
                    <img
                      style={{ filter: 'brightness(0) invert(1)' }}
                      src='/images/icon-bin-orange.png'
                      alt='icon-bin' width='18' height='25' />
                    <span>นำออกจากรายการ</span>
                  </div>
                )}
              </div>
            ) : (
              <div>
                <div className={classes.stockAmount}>
                  <strong>คลัง: </strong>
                  <span>{stockAmount} {_get(_find(product.units || [], ({ unitId }) => `${unitId}` === selectedUnitId), 'unit')}</span>
                </div>
                <div className={classes.amount}>
                  <span className={classes.label}>จำนวน </span>
                  <input
                    className={_get(cartProductMap[`${product.productCode}-${selectedUnitId}`], 'amount') && classes.active}
                    type='text'
                    onKeyDown={this._onEnter}
                    value={this.state.amount} onChange={e => this._onAmountChange(e.target.value, stockAmount)} />
                  <div className={classes.btnCart} onClick={this._onAddToCart}>
                    <img src='/images/icon-cart-orange.png' alt='icon-cart' />
                    <span>ใส่ตะกร้า</span>
                  </div>
                </div>
              </div>
            )}
            <div className={`${classes.btnWishlist} ${product.userId && classes.added}`} onClick={() => this._onWishlist(Boolean(product.userId))}>
              <span>{product.userId ? '-' : '+'} WISHLIST</span>
            </div>
            {Boolean(product.description) && (
              <div className={classes.description}>
                <div className={classes.header}>รายละเอียดสินค้า</div>
                <div className={classes.body}>
                  <span>{resolveBackSlash(product.description)}</span>
                </div>
              </div>
            )}
          </div>
        </div>
        {Boolean((recommendations || []).length) && (
          <div>
            <div className={classes.separator} />
            <div className={classes.recommendedProductsLabel}>สินค้าที่เกี่ยวข้อง</div>
            <div>{recommendations.map(this._renderProduct)}</div>
          </div>
        )}
        <div className={classes.separator} />
        <div className={classes.banners}>
          {banners.map(this._renderBanner)}
        </div>
        {this.state.modalVisible && (
          <div className='overlay'>
            <div className={`overlay-cell ${classes.modal}`} onClick={this._onCloseModal}>
              <div className={classes.imageWrapper}>
                <img role='presentation' src={this.state.modalImagePath} />
                <div className={classes.wmWrapper}>
                  {Boolean(product.freeDelivery) && <img className={classes.freeDelivery} src='/images/icon-free-shipping.svg' alt='Free Delivery' />}
                  <img className={classes.wm} src='/images/watermark.png' alt='watermark' width='132' height='44' />
                </div>
              </div>
            </div>
          </div>
        )}
      </section>
    )
  }
}

export default ProductDetail



// WEBPACK FOOTER //
// ./src/containers/User/Product/ProductDetail.js